import Highlight, { defaultProps } from "prism-react-renderer";
import theme from "prism-react-renderer/themes/github";
import { Pre, Line, LineNo, LineContent } from "./styles";

// JS Sample Code
const javascript = `const WebSocket = require('ws');
const accessToken = <token_here>;
var websocket = new WebSocket("wss://<base_url>/transactionalws?access_token=" + accessToken);
websocket.onopen = function (e) { console.log("Connected");
};
websocket.onclose = function (e) { console.log("Closed");
};
websocket.onmessage = function (e) { console.log(e.data);
};
websocket.onerror = function (e) { console.log("Error", e.message);
};`;

function EFDAAF() {
  return (
    <Highlight
      {...defaultProps}
      theme={theme}
      code={javascript}
      language="javascript"
    >
      {({ className, style, tokens, getLineProps, getTokenProps }) => (
        <Pre className={className} style={style}>
          {tokens.map((line, i) => (
            <Line key={i} {...getLineProps({ line, key: i })}>
              <LineNo>{i + 1}</LineNo>
              <LineContent>
                {line.map((token, key) => (
                  <span key={key} {...getTokenProps({ token, key })} />
                ))}
              </LineContent>
            </Line>
          ))}
        </Pre>
      )}
    </Highlight>
  );
}
export default EFDAAF;
